import styled, { keyframes } from "styled-components";

export const BrandListingScreen = styled.div`
  overflow-y: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
  height: 100vh;
  background-color: #f2f2f2;

  &::-webkit-scrollbar {
    display: none;
  }

  .brand-listing-header {
    padding: 16px;
    padding-bottom: 8px;
    border-bottom: 1px solid #ccc;
    background-color: #fff;

    .header-container {
      align-items: center;
      display: flex;
      margin-bottom: 12px;
    }

    > div > img.brand-mmt-logo {
      height: 24px;
      width: 24px;
      margin-right: 4px;
    }

    .trip-destination-view {
      border: 1px solid #d7d7d7;
      padding: 14px 12px;
      border-radius: 8px;
      background-color: #fafafa;
      align-items: center;
      display: flex;

      img.brand-back-btn {
        margin-right: 11px;
      }
    }

    .brand-mmt-header-title {
      font-size: 12px;
      font-weight: 900;
      font-family: "Lato";
    }
  }

  .brand-listing-container {
    background-color: #f2f2f2;
    padding: 16px;
    padding-bottom: 150px;

    .brand-filter-sec {
      padding-bottom: 8px;

      > .filter-label {
        font-size: 12px;
        font-family: "Lato";
        font-weight: 500;
        margin-bottom: 4px;
        color: #4a4a4a;
      }

      > p > .filterTexts {
        font-size: 12px;
        font-weight: 400;
        font-family: "Lato";
      }

      > .filterDivider {
        margin: 0px 2px;
        font-size: 12px;
      }
    }

    .brand-cab-card-container {
      color: #141823;
      font-size: 12px;
      font-family: "Lato";
      font-weight: 400;
      margin-bottom: 8px;

      .recommended-section {
        padding-top: 8px;
        padding-bottom: 8px;
        display: flex;
        align-items: center;

        span.circleSeperate {
          height: 4px;
          width: 4px;
          background-color: #007e7d;
          margin: 0px 8px;
          border-radius: 50%;
        }

        .preferredTxt {
          padding: 3px 8px;
          background: #43e1a833;
          border-radius: 16px;
          color: #007e7d;
          font-size: 12px;
          font-family: "Lato";
          font-weight: 700;
        }

        .reLabel {
          font-size: 12px;
          font-family: "Lato";
          font-weight: 500;
          color: #4a4a4a;
        }
      }

      .brand-cab-card {
        padding: 12px;
        border-radius: 16px;
        background-color: #fff;
        margin-bottom: 8px;

        &.selected {
          border: 1px solid #0c58b4;
          margin-bottom: 16px;
          border-radius: 16px;
          box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.2);
        }

        > .brand-cab-details {
          display: flex;
          width: 100%;
          padding-bottom: 8px;

          .img-section {
            position: relative;
            width: 80px;
            height: 73px;
            background: #e8f0fb;
            justify-content: center;
            align-items: center;
            display: flex;
            border-radius: 8px;

            > .img-brandLogo {
              top: -8px;
              position: absolute;
              justify-content: center;
              align-items: center;
              display: flex;
              border-radius: 16px;
              box-shadow: 0px 1px 4px 0px #00000033;
              background-color: #fff;
              left: 50%;
              transform: translate(-50%, 0);
              height: 24px;
              width: 50px;
            }

            > .brand-cab-img {
              width: 68px;
              height: 42px;
              object-fit: contain;
            }
          }

          .brand-cab-info {
            margin-left: 8px;
            display: flex;
            justify-content: space-between;
            width: 100%;

            .brand-label {
              > div {
                display: flex;
                margin-bottom: 2px;
                align-items: center;

                > p {
                  font-family: "Lato";
                  font-weight: 700;
                  font-size: 18px;
                }
              }

              > p {
                font-family: "Lato";
                font-weight: 400;
                font-size: 12px;
                color: #4a4a4a;
              }

              .cab-rating-box {
                display: flex;
                background: #0c58b4;
                justify-content: center;
                align-items: center;
                border-radius: 4px;
                padding: 1px 4px;
                margin-left: 4px;
                max-height: 18px;
                max-width: 38px;

                > span {
                  color: #fff;
                  font-family: "Lato";
                  font-weight: 700;
                  font-size: 12px;
                  margin-left: 4px;
                }
              }
            }
          }
        }
      }
    }
  }

  .brand-features {
    display: flex;

    .brand-feat-item {
      display: flex;
      align-items: center;
      justify-content: center;

      .featureImgCont {
        display: flex;
        height: 12px;
        width: 12px;
        border-radius: 50%;
        padding: 2px;
        margin-right: 2px;
        justify-content: center;
        align-items: center;

        > img {
          width: 9px;
          height: 9px;
          padding-right: 1px;
          padding-bottom: 1px;
        }
      }

      .brand-feature-text {
        font-family: "Lato";
        font-weight: 500;
        font-size: 12px;
      }

      .dotSeperate-feature {
        height: 4px;
        width: 4px;
        border-radius: 50%;
        margin-right: 8px;
        margin-left: 8px;
      }
    }
  }

  .footer-btn-sec {
    padding: 16px;
    position: fixed;
    bottom: 0px;
    background: #fff;
    z-index: 10;
    left: 0;
    right: 0;
    box-shadow: inset 0px 2px 0px -1px rgba(50, 50, 50, 0.15);

    p {
      font-family: "Lato";
      font-weight: 700;
      font-size: 12px;
      color: #4a4a4a;
      margin-bottom: 12px;
      text-align: center;
    }

    > .primaryCustBtn {
      width: 100%;
      padding: 13px;
    }
  }

  .pwa-login {
    font-family: "Lato";
  }
`;

export const SingleLineLocation = styled.span`
  font-family: "Lato";
  font-weight: 900;
  font-size: 14px;
`;

export const SingleLineTime = styled.span`
  font-family: "Lato";
  font-weight: 400;
  font-size: 12px;
`;

export const TripInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 4px;
`;

export const BrandFareInfo = styled.div`
  > .total-amt-txt {
    text-align: right;
    font-family: "Lato";
    font-weight: 700;
    font-size: 18px;
    margin-bottom: 2px;
  }

  > .tax-msg-txt {
    font-family: "Lato";
    font-weight: 500;
    font-size: 12px;
    margin-bottom: 2px;
    color: #757575;
    font-style: italic;
    text-align: right;
    max-width: 100px;
  }
`;

export const BrandLabelContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 70%;

  .dot-separator {
    margin: 0 4px;
  }
`;

const spin = keyframes`
  from {transform:rotate(0deg);}
  to {transform:rotate(360deg);}
`;

export const OtherOptionText = styled.div`
  margin-top: 16px;
  margin-bottom: 8px;
  color: #4a4a4a;
  font-size: 12px;
  font-family: "Lato";
  font-weight: 400;
`;

export const OtherRecommendedSection = styled.div`
  padding: 16px 0px;
  display: flex;
  align-items: center;
  font-size: 12px;
  font-family: "Lato";
  font-weight: 500;
  color: #4a4a4a;
`;

export const CabPaymentCont = styled.div`
  display: flex;
  flex-direction: column;
  font-family: "Lato";
  font-weight: 400;
`;

export const BluePrimaryBtn = styled.button`
  outline: 0;
  border: 0;
  display: inline-block;
  background-image: linear-gradient(92deg, #53b2fe 0%, #065af3 100%);
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
  color: #fff;
  text-transform: uppercase;
  font-family: "Lato";
  font-weight: 900;
  font-size: 16px;
  text-align: center;
  border-radius: 8px;
  padding: 15px 20px;
`;

export const BtnLoader = styled.span`
  display: inline-flex;
  color: transparent;
  height: 18px;
  width: 18px;
  animation: ${spin} 0.8s infinite linear;
  border: 2px solid #fff;
  border-right-color: transparent;
  border-radius: 50%;
  margin: -2px auto;
`;

export const SubText = styled.p`
  font-size: 12px;
  font-family: "Lato";
  font-weight: 700;
`;

export const StarImgIc = styled.img`
  width: 10px;
  height: 10px;
`;

export const LineImg = styled.img`
  height: 1px;
  width: 100%;
  margin-bottom: 8px;
`;

export const BrandImgSec = styled.img`
  height: 18px;
  object-fit: contain;
`;

export const TimeLeftText = styled.p`
  font-family: "Lato";
  font-weight: 700;
  font-size: 14px;
  color: #000;
`;

export const BottomSheetTopCont = styled.div`
  display: flex;
  justify-content: space-between;

  & .title {
    font-family: "Lato";
    font-weight: 700;
    font-size: 24px;
    color: #000;
    margin-top: 4px;
  }

  img {
    height: 24px;
    width: 24px;
  }
`;

export const BottomSheetSubtitle = styled.p`
  margin-top: 24px;
  font-family: "Lato";
  font-size: 16px;
  font-weight: 500;
  color: #4a4a4a;
`;

export const BottomSheetCommTxtCont = styled.div`
  display: flex;
  margin-top: 16px;
  margin-bottom: 24px;

  & .commTitle {
    font-family: "Lato";
    font-size: 14px;
    font-weight: 400;
    color: #757575;
    margin-left: 6px;
  }

  img {
    height: 24px;
    width: 24px;
  }
`;

export const GenderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const CustomRadioWrap = styled.label`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
`;

export const labelTxt = styled.span`
  font-size: 16px;
  font-family: "Lato";
  padding-left: 1rem;
  font-weight: 700;
  color: #000;
`;

export const InputCont = styled.div(
  (props) => `
  margin-bottom: 12px;

  & .inoutContVal {
    padding: 6px 8px 6px 12px;
    border: 1px solid #d8d8d8;
    border-radius: 8px;
    background-color: #f6f6f6;
  }

  & .title {
    font-family: 'Lato';
    font-size: 12px;
    font-weight: 500;
    color: #757575;
  }

  & .prefixInputCont {
    display: flex;
    align-items: center;
  }

  & .prefix {
    font-family: 'Lato';
    font-size: 16px;
    font-weight: 700;
    color: #000;
    margin-right: 4px;
  }

  & .errorText {
    font-size: 12px;
    font-weight: 500;
    font-family: 'Lato';
    color: #ff3a5c;
    margin-top: 12px;
  }

  input {
    border: none;
    width: ${props?.width ? props?.width : "100%"};
    font-family: 'Lato';
    font-size: 16px;
    font-weight: 700;
    color: #000;
    background: none;
    padding: 4px 0;
  }
`
);

export const BottomSheetBtnCont = styled.div`
  margin-top: 36px;
`;
